import { useSyncExternalStore } from "react";
import { noteServerTime, serverNow } from "./serverClock";

// „Часовникът" на обедните менюта: брояч, който расте всеки път, когато обедно
// меню трябва да се появи или изчезне. `useMenu` го слага в зависимостите на
// `select`, за да преизчисли активните обедни групи БЕЗ нова заявка — така
// групата изчезва навреме и без интернет (касата връща старото копие на
// менюто). Кой го мести: `useLunchCatalogRefresh` в „Маркиране".

let tick = 0;
const listeners = new Set<() => void>();

export const bumpLunchClock = () => {
  tick += 1;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useLunchClockTick = () =>
  useSyncExternalStore(subscribe, () => tick, () => tick);

// Обедното меню се показва/скрива по `lunchNow()`, за да изчезне в същата
// секунда, в която сървърът спира да го приема — и на терминал с
// избързал/изостанал часовник. Самата разлика „сървър − терминал" живее в
// `serverClock.ts` (ползва я и броячът на задържаната поръчка); старите имена
// остават, за да не се пипат извикващите.
export const noteLunchServerTime = noteServerTime;

export const lunchNow = serverNow;
